import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { FormTitle } from "../../components/FormComponents/FormTitle/FormTitle";
import OTPInput from "../../components/OTPInput/OTPInput";

function LoginOTPInput(props: {
  value: string | undefined;
  onValueChange: (value: string) => void;
  footerMessage?: React.ReactNode | string;
  showTitle?: boolean;
  hasError?: boolean;
  lowerFooter?: React.ReactNode | string | null;
}) {
  const {
    value,
    onValueChange: setValue,
    footerMessage,
    showTitle = true,
    hasError = false,
    lowerFooter = null,
  } = props;
  const { palette } = useTheme();

  const [{ otp, numInputs, inputType }, setConfig] = useState({
    otp: value || "",
    numInputs: 6,
    inputType: "text" as const,
  });

  const handleOTPChange = (otp: string) => {
    setConfig((prevConfig) => ({ ...prevConfig, otp }));
    setValue(otp);
  };

  return (
    <Box>
      <FormTitle title="One Time Password" showTitle={showTitle} />
      <OTPInput
        inputStyle="inputStyle"
        numInputs={numInputs}
        onChange={handleOTPChange}
        value={otp}
        inputType={inputType}
        hasError={hasError}
        renderInput={(props) => <input {...props} />}
      />
      {footerMessage ? (
        <Typography sx={{ mt: 1, color: palette.text.secondary }}>
          {footerMessage}
        </Typography>
      ) : null}
      {lowerFooter ? (
          <Typography sx={{ mt: 1, color: palette.text.secondary }}>
            {lowerFooter}
          </Typography>
      ) : null}
    </Box>
  );
}

export default LoginOTPInput;
